import { CartonData } from '@/types/CartonData.type';

export function isCartonNumberInvalid(carton: CartonData): boolean {
    const value = carton?.cartonNumber;
    return !value || `${value}`.trim() === '';
}


